import React, { useEffect, useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Tag } from "primereact/tag";
import { Image } from "primereact/image";
import { usePresentacionContext } from "../context/presentacion.context";
import { maximoTamanoImagen } from "../../presentaciones/services/presentaciones.service";
import { Messages } from "primereact/messages";
import { Dialog } from "primereact/dialog";
import { Viewer, ViewerFormats } from "../../shared/components/viewer";
import { HttpStatusCode } from "axios";
import { getExtension } from "../../shared/utilitties/generals";
import '../../shared/components/viewer.css';
import { KB } from "../utilities/constants";
import { INICIADA_COMERCIO } from "../utilities/constants";

export const ComprobanteFileUpload = () => {
  const {
    setFile,
    setFileName,
    imageComprobante,
    setImageComprobante,
    comprobanteSeleccionado, presentacionEditable,
    maxSize, setMaxSize,
    descargarPdf,
    presentacionOCR,
    presentacionState
  } = usePresentacionContext();

  const [totalSize, setTotalSize] = useState(0);
  const toast = useRef<Toast>(null);
  const fileUploadRef = useRef<FileUpload>(null);
  const maxSizeOnMb = maxSize / 1000000;
  const messages = useRef<any>(null);
  const [showModalFile, setShowModalFile] = useState<{ show: boolean, type: string | null }>({ show: false, type: null });
  const FILE_DOWNLOAD_LIMIT_KB:number = parseInt(process.env.REACT_APP_FILE_DOWNLOAD_LIMIT!);
  
  const allowedExtensions = ".pdf,.jpg,.jpeg,.png,.gif,.bmp,.tiff,.svg";
  let dataURI = "";
  if (Object.keys(imageComprobante).length > 0) dataURI = `${imageComprobante.imgBase64}`;

  useEffect(() => {
    (async () => {
      const { data, status } = await maximoTamanoImagen()
      if (status == HttpStatusCode.Ok) setMaxSize(data);
      else setMaxSize(1000000);
    })()
    return () => {
      setImageComprobante({})
    }
  }, [])

  const setImage = (e: any) => {
    let _totalSize = totalSize;
    Array.from(e.files).forEach((file: any) => {
      _totalSize += file.size;
    });
    setTotalSize(_totalSize);
  }

  const onTemplateSelect = (e: any) => {
    messages.current?.clear()
    const file = e.files[0];
    if (file.type === "application/pdf" || file.type.includes("image/")) {
      if (file.size > maxSize) {
        if (file.type.includes("image/")) {
          messages.current.show([
            { severity: 'warn', detail: 'El archivo es demasiado pesado, será reducida la calidad.', sticky: true }
          ]);
          customBase64Uploader(e);
          setImage(e);
        }
        if (file.type === "application/pdf") {
          toast.current?.show({ severity: "error", summary: "Error", detail: `Los Pdf no pueden ser mayores a ${maxSizeOnMb} MB.`, });
          onTemplateClear();
        }
        else {
          customBase64Uploader(e);
          setImage(e);
        }
      }
      else {
        customBase64Uploader(e);
        setImage(e);
        toast.current?.show({ severity: "success", summary: "Ok", detail: "Archivo cargado correctamente.", });
      }
    }
    else {
      toast.current?.show({ severity: "error", summary: "Error", detail: "El tipo de archivo no es válido.", });
      onTemplateClear();
    }

  };

  const onTemplateUpload = (e: any) => {
    let _totalSize = 0;
    Array.from(e.files).forEach((file: any) => {
      _totalSize += file.size || 0;
    });
    setTotalSize(_totalSize);
    toast.current?.show({
      severity: "info",
      summary: "Success",
      detail: "File Uploaded",
    });
  };

  const onTemplateRemove = (file: any, callback: any) => {
    setTotalSize(totalSize - file.size);
    setFile(null);
    setFileName(null);
    callback();
   
  };

  const onTemplateClear = () => {
    setTotalSize(0);
    fileUploadRef.current?.clear();
    
  };

  const headerTemplate = (options: any) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;
    if(presentacionOCR && presentacionState === INICIADA_COMERCIO && JSON.stringify(comprobanteSeleccionado) !== "{}"){
      return(<></>)
    }
    return (
      <div
        className={className}
        style={{
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
        {chooseButton}

        <span style={{ fontSize: '14px' }}>Los archivos no pueden ser mayores a {maxSizeOnMb} MB</span>
      </div>
    );
  };

  const itemTemplate = (file: any, props: any) => {
    return (
      //"flex align-items-center flex-wrap"
      <div className="p-d-flex p-ai-center flex-wrap">
        <div className="p-d-flex p-ai-center" style={{ width: "50%", fontSize: '12px' }}>
          {file.name.indexOf(".pdf") > 0
            ? <i className="pi pi-file-pdf mr-2"></i>
            : <img
              alt={file.name}
              role="presentation"
              src={file.objectURL}
              width={100}
              style={{ marginRight: "12px" }}
            />
          }

          {/*"flex flex-column text-left ml-3" */}
          <span className="p-d-flex p-flex-column p-ai-center" style={{ fontSize: '12px' }} >
            {file.name}
            <small>{new Date().toLocaleDateString()}</small>
          </span>
        </div>
        <Tag
          value={props.formatSize}
          severity="warning"
          className="px-3 py-2"
        />
        <Button
          type="button"
          icon="pi pi-times"
          className="p-button-outlined p-button-rounded p-button-danger ml-auto"
          onClick={() => onTemplateRemove(file, props.onRemove)}
        />
      </div>
    );
  };
const handleFile = (e:any) =>{
  e.preventDefault(); 
  const bin = atob(imageComprobante.imgBase64);
  const size:number = Math.round(bin.length / KB);
  if(size <= FILE_DOWNLOAD_LIMIT_KB){
    setShowModalFile({ show: true, type: 'pdf' });
  }else{
    dowloadPdf(e,imageComprobante.imgBase64,imageComprobante.nombreImagen)
  }
} 
  const emptyTemplate = () => {
    if (JSON.stringify(comprobanteSeleccionado) === "{}") {
      return (
        <div className="p-d-flex p-ai-center p-jc-center">
          <i
            className="pi pi-image p-2"
            style={{
              fontSize: "2.5rem",
              borderRadius: "50%",
              backgroundColor: "var(--surface-b)",
              color: "var(--surface-d)",
            }}
          ></i>
          <span
            style={{
              fontSize: "1.2rem",
              color: "var(--text-color-secondary)",
            }}
          >
            Arrastra tu comprobante aquí.
          </span>
        </div>
      )

    } else {
      if (Object.keys(imageComprobante).length > 0 && imageComprobante.nombreImagen.indexOf(".pdf") > 0) {
        return (
          <div className="grid" style={{ justifyContent: 'center', marginLeft: '2rem', display: 'grid', fontSize: '14px' }}>
            <div className="button-demo">
              <Button  className="p-button-link" style={{'cursor':'pointer'}} onClick={(e) => handleFile(e)}>
                <i className="pi pi-file-pdf mr-2"></i>
                <span>{imageComprobante.nombreImagen}</span>
              </Button>
            {descargarPdf && <div className="mt-2">
                <Tag icon="pi pi-exclamation-triangle" severity="warning" value={`La vista previa está disponible para archivos PDF de hasta ${FILE_DOWNLOAD_LIMIT_KB} KB`}></Tag>
            </div>
            }
            </div>
          </div>
        )

      } else {
        return (
          <div className="p-d-flex p-ai-center p-jc-center">
            {dataURI === "" ? <Tag className="mr-2" icon="pi pi-exclamation-triangle" severity='danger' value="Archivo no encontrado"></Tag>
              : <Image
                src={`data:image;base64,${dataURI}`}
                alt="Image"
                width="80"
                height="60"
                onClick={(e) => { e.preventDefault(); setShowModalFile({ show: true, type: getExtension(imageComprobante.nombreImagen) }); }}
              />}
          </div>
        )
      }
    }
  };

  function dowloadPdf(e: any, fileBase64: any, nombrePDF: any) {
    e.preventDefault()
    let result = base64ToBlob(fileBase64)
    const downloadLink = document.createElement("a");
    const fileName = nombrePDF;
    downloadLink.href = window.URL.createObjectURL(result);;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  function base64ToBlob(fileBase64: any) {
    const binaryString = window.atob(fileBase64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], { type: 'application/pdf' });
  };

  const getBase64 = (file: any) => {
    return new Promise(resolve => {
      // Make new FileReader
      let reader = new FileReader();
      // Convert the file to base64 text
      reader.readAsDataURL(file);
      // on reader load somthing...
      reader.onload = () => {
        resolve(reader.result);
      };
    });
  };

  const handleFileInputChange = (e: any) => {
    setFileName(e.name)
    getBase64(e)
      .then(result => {
        setFile(result);
      })
      .catch(err => {
        console.log(err);
      });
  };


  const customBase64Uploader = async (event: any) => {
    const file = event.files[0];
    if (file.type === "application/pdf") {
      handleFileInputChange(file)
    } else {
      const reader = new FileReader();
      let blob = await fetch(file.objectURL).then((r) => r.blob());
      reader.readAsDataURL(blob);
      reader.onloadend = function () {
        const base64data = reader.result;
        setFile(base64data);
        setFileName(file.name);
      };
    }
  };

  const chooseOptions = {
    icon: "pi pi-fw pi-images",
    iconOnly: true,
    className: "custom-choose-btn p-button-rounded p-button-outlined",
  };

  const cancelOptions = {
    icon: "pi pi-fw pi-times",
    iconOnly: true,
    className:
      "custom-cancel-btn p-button-danger p-button-rounded p-button-outlined",
  };

  return (
    <div>
      <Dialog maximizable={showModalFile?.type == 'pdf' ?? true} modal
        className="eden-file-dialog"
        header={imageComprobante.nombreImagen}
        visible={showModalFile.show}
        onHide={() => setShowModalFile({ ...showModalFile, show: false })}
        style={{ width: '75vw', height: '75vh' }}>
        <Viewer fileStyle={{ height: 'inherit', width: 'inherit' }} format={showModalFile.type as ViewerFormats} loading={false} base64={dataURI} />
      </Dialog>
      <Toast ref={toast} />
      <Messages style={{ fontSize: '12px', height: '50%' }} ref={messages} />
      <Tooltip target=".custom-choose-btn" content="Cargar" position="bottom" />
      <Tooltip target=".custom-cancel-btn" content="Clear" position="bottom" />
      <FileUpload
        ref={fileUploadRef}
        name="demo[]"
        url="./upload"
        accept={allowedExtensions}
        onUpload={onTemplateUpload}
        onError={onTemplateClear}
        onClear={onTemplateClear}
        headerTemplate={presentacionEditable ? headerTemplate : <></>}
        itemTemplate={itemTemplate}
        emptyTemplate={emptyTemplate}
        chooseOptions={chooseOptions}
        cancelOptions={cancelOptions}
        onSelect={(e) => onTemplateSelect(e)} //Valido cuando se carga la imagen
      />
    </div>
  );
};
